import { Button, Input, Select, Table } from 'antd';
import { Option } from 'antd/es/mentions';
import axios from 'axios';
import React, { useState ,useEffect } from 'react'
import { toast } from 'react-toastify';
import { TemperMasterDelete, TemperMasterGet, TemperMasterSave, TemperMasterUpdate } from '../../../AllAPI/MasterAPI/ProductionMasterApi';
import "../../MainCSS.css";
import "aos/dist/aos.css";



const TemperMaster = () => {
  const commonHeaders = {
    headers: {
      createdBy: 1,
      updatedBy: 2,
      userIp: '',
      userLat: '',
      userLong: '',
      deviceSign: '',
    },
  };

    const [errors, setErrors] = useState({
          temperName: "",
          description: "",
      
        });
      
        const [pageSize, setPageSize] = useState(10);
        const [filteredData, setFilteredData] = useState([]);
        const [currentPage, setCurrentPage] = useState(1);
        const [totalEntries, setTotalEntries] = useState(0);
      
        const [temperId, setTemperId] = useState("");
        const [temperName, setTemperName] = useState("");
        const [description, setDescription] = useState("");
      
        const [allTemper, setAllTemper] = useState([]);
        const [submitButton, setSubmitButton] = useState(true);
        const [updateButton, setUpdateButton] = useState(false);
      
        //======Search data from table===============
        const handleSearch = (value) => {
          const searchValue = value.toLowerCase();
        
          const filtered = allTemper.filter((item) =>
            Object.values(item).some((val) =>
              String(val ?? "").toLowerCase().includes(searchValue)
            )
          );
        
          setFilteredData(filtered);
          setTotalEntries(filtered.length);
          setCurrentPage(1);
        };
      
        //==========Pagination=======================
        const handlePageSizeChange = (value) => {
          setPageSize(value);
        };
      
       // ==============Get table data================
    let isTemperMasterFetched = false;
    useEffect(() => {
      if (isTemperMasterFetched) return;
          fetchTemperMaster();
      isTemperMasterFetched = true;
    }, []);
  
    let isError = false;
  
    const fetchTemperMaster = async () => {
      try {
        const response = await axios.get(TemperMasterGet ,commonHeaders);
       if (response.data && response.data.length > 0) {
          setAllTemper(response.data);
          setFilteredData(response.data); // Set initial filtered data as the fetched data
          setTotalEntries(response.data.length); // Set the total number of entries
        }
        else{
            toast.warn("No data available !!");
                    setAllTemper([]);
                    setFilteredData([]);
                    setTotalEntries([]);
        }
      } catch (error) {
        if (!isError) {
          console.error("Error fetching Temper Master data:", error);
          toast.error("Failed to fetch Temper Master data");
          isError = true; // Set the flag to prevent double toast
        }
      }
    };
      
        // const columns = [
        //   {
        //     title: "Sr.No.",
        //     dataIndex: "",
        //     key: "index",
        //     render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
        //   },
         
        //   {
        //     title:"Temper Name",
        //     dataIndex: "temperName",
        //     key: "temperName",
        //        sorter: (a, b) => a.temperName.localeCompare(b.temperName),
        //   },
        //   {
        //     title: "Description",
        //     dataIndex: "description",
        //     key: "description",
        //        sorter: (a, b) => a.description.localeCompare(b.description),
        //   },
       
        //   {
        //     title: "Actions",
        //     key: "actions",
        //     render: (text, record) => (
        //       <div>
        //         <span
        //           type="submit"
        //           style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
        //           onClick={() => handleEditDataButton(record)}
        //         >
        //           <i class="fa-solid fa-pen-to-square"></i>
        //         </span>
        //         <span
        //           type="submit"
        //           style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
        //           onClick={() => handleDeleteData(record)}
        //         >
        //           <i class="fa-solid fa-trash"></i>
        //         </span>
        //       </div>
        //     ),
        //   },
        // ];
      
        const columns = [
  {
    title: "Sr.No.",
    dataIndex: "",
    key: "index",
    render: (text, record, index) => (currentPage - 1) * pageSize + index + 1,
  },
  {
    title: "Temper Name",
    dataIndex: "temperName",
    key: "temperName",
    sorter: (a, b) => {
      const valA = a.temperName ?? '';
      const valB = b.temperName ?? '';
      return String(valA).localeCompare(String(valB));
    },
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
    sorter: (a, b) => {
      const valA = a.description ?? '';
      const valB = b.description ?? '';
      return String(valA).localeCompare(String(valB));
    },
  },
  {
    title: "Actions",
    key: "actions",
    render: (text, record) => (
      <div>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "#349ff3", marginRight: "10px" }}
          onClick={() => handleEditDataButton(record)}
        >
          <i className="fa-solid fa-pen-to-square"></i>
        </span>
        <span
          type="submit"
          style={{ fontSize: "12px", color: "red", marginLeft: "10px" }}
          onClick={() => handleDeleteData(record)}
        >
          <i className="fa-solid fa-trash"></i>
        </span>
      </div>
    ),
  },
          ];


        const components = {
          header: {
            cell: ({ children, ...restProps }) => (
              <th
                {...restProps}
                style={{
                  backgroundColor: "#023e7d",
                  color: "#fff",
                  padding: "10px",
                  fontSize: "15px",
                  borderRadius: "0px",
                }}
              >
                {children}
              </th>
            ),
          },
          body: {
            row: ({ children, ...restProps }) => (
              <tr
                {...restProps}
                style={{
                  backgroundColor: "#f0f7fd",
                }}
              >
                {children}
              </tr>
            ),
            cell: ({ children, ...restProps }) => (
              <td
                {...restProps}
                style={{
                  padding: "8px",
                   fontSize: "15px",
                }}
              >
                {children}
              </td>
            ),
          },
        };

          // ========Submit data to table==============
                  const handleSubmit = async () => {
                    let isValid = true;
                    const errorObj = {};
                
                    if (!temperName.trim()) {
                      isValid = false;
                      errorObj.temperName = "Temper Name is required *";
                    }
                    
                    if (!description.trim()) {
                      isValid = false;
                      errorObj.description = "Description is required *";
                    }
                
                
                    setErrors(errorObj); // Set error messages
                
                    if (!isValid) return;
                
                    const bodyData = {
                      temperName: temperName,
                      description:description,
                    };
                
                    try {
                      const response = await axios.post(TemperMasterSave, bodyData ,commonHeaders);
        
                      if (response.data === "CREATED") {
                        toast.success("Temper Name added successfully!");
                        fetchTemperMaster();
                        handleCancel();
                      } else if (response.data === "ALREADYEXISTED") {
                        toast.warn("Temper Name already exist!");
                        //handleCancel();
                      }
                    } catch (error) {
                      console.error("Error during API call:", error);
                      toast.error("Error occurred while submitting data");
                    }
                  };
                  //==================== Handle Cancel button =====================
                  const handleCancel = () => {
                    setUpdateButton(false);
                    setSubmitButton(true);
                    setDescription("");
                    setTemperName("");
                    setErrors("");
                  };
                // ========Update data from table============
                const handleEditDataButton = (item) => {
                  setUpdateButton(true);
                  setSubmitButton(false);
                  window.scrollTo(0, 0);
                  setTemperName(item.temperName);
                  setDescription(item.description);
                  setTemperId(item.id);
                };
                const handleUpdate = async () => {
                  if (!temperName) {
                    toast.warn("Please enter a  Name!");
                    return;
                  }
                  if (!description) {
                    toast.warn("Please enter Description!");
                    return;
                  }
              
              
                 
                  const bodyData = {
                    id:temperId,
                    temperName: temperName,
                    description:description,
                
                  };
              
                  try {
                    const response = await axios.put(TemperMasterUpdate, bodyData ,commonHeaders);
                    
                    if (response.data === "UPDATED") {
                      toast.success("Temper Name updated successfully!");
                     fetchTemperMaster();
                      handleCancel();
                    } else if (response.data === "ALREADYEXISTED") {
                      toast.warn("Temper Name already exist!");
                      //handleCancel();
                    }
                  } catch (error) {
                    console.error("Error during API call:", error);
                    toast.error("Error occurred while updating data");
                  }
                };
                //============================== Delete data from table ======================================
 const handleDeleteData = async (item) => {
  const confirmDelete = window.confirm(
    `Are you sure you want to delete the Temper "${item.temperName}"?`
  );
  if (!confirmDelete) return;

  try {
const response = await axios.delete(
`${TemperMasterDelete}?id=${item.id}`,commonHeaders
   );

    if (response.data === "DELETED") {
      toast.success("Temper deleted successfully!");
      fetchTemperMaster();
      handleCancel();
    }
  } catch (error) {
    console.error("Error during delete operation:", error);
    toast.error("Error occurred while deleting ");
  }
};
  return (
    <div className="px-5 py-3" style={{ fontSize: "15px" }}>
 <div  className="row mt-3 p-3 pb-5 pt-3 mb-3 rounded" style={{ backgroundColor: '#e0efff' }}>
          
  <div className="col-12">


    <div className="p-0 m-0">
   <div className="row px-md-5 mt-3 p-2 ">
   
   <div className="row p-0 m-0">
   <div className="col-12 col-lg-4"></div>
   <div className="col-12 col-lg-4">
   <div className="row p-0 m-0">
      
      {/* Temper Name and Description in the same row */}
      <div className="col-12 py-1">
        <label className="labels">Temper Name</label>
        <Input
          value={temperName}
          maxLength="250"
          onChange={(e) => setTemperName(e.target.value)}
          placeholder="Enter Name"
          style={{ width: '100%' }}
        />
        {errors.temperName && <div className="errorField">{errors.temperName}</div>}
      </div>

      <div className="col-12 py-1">
        <label className="labels">Description</label>
        <Input.TextArea
          value={description}
          maxLength="250"
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Enter description"
          style={{ width: '100%' }}
        />
        {errors.description && <div className="errorField">{errors.description}</div>}
      </div>
  </div>
  </div>
  </div>
          {/* Buttons */}
          <div className="col-12 text-center pt-3">
            <Button
              type="submit"
              className="CancelBtn mx-1"
               onClick={handleCancel}
            >
              Cancel
            </Button>
            {submitButton && (
              <Button
                type="submit"
                className="SubmitBtn mx-1"
                   
                onClick={handleSubmit}
              >
                Submit
              </Button>
            )}
            {updateButton && (
              <Button
                type="submit"
                className="UpdateBtn mx-1"
                 
                onClick={handleUpdate}
              >
                Update
              </Button>
            )}
          </div>
  

  
    <div className="col-12 p-0 mt-3" style={{ borderBottom: "2px solid #bfb597" }}></div></div>
  
    {/*================ Table =========================*/}
    <div className="row m-0 p-2  px-md-5 pt-md-0 mt-3">
      <div className="col-12 py-3 shadow border" style={{  backgroundColor: "white" }}>
        <div className="col-12 px-md-5" style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <span style={{ fontSize: "14px" }}>Show entries &nbsp;</span>
            <Select
              defaultValue={pageSize}
              onChange={handlePageSizeChange}
              style={{ width: 120, textAlign: "center" }}
            >
              <Option value={10}>10</Option>
              <Option value={20}>20</Option>
              <Option value={30}>30</Option>
            </Select>
          </div>
  
          <div className="pt-4 pt-md-0">
            <Input.Search
              placeholder="Search"
               onChange={(e) => handleSearch(e.target.value)}
              style={{ width: 200, marginBottom: 16 }}
            />
          </div>
        </div>
  
        <div style={{ backgroundColor: "white" }}>
          <Table
            bordered
            style={{ padding: "0px 20px", overflowX: "auto" }}
            columns={columns}
            dataSource={filteredData}
            pagination={{
              pageSize: pageSize,
              total: totalEntries,
              showTotal: (total, range) =>
                `Showing ${range[0]} to ${range[1]} of ${total} entries`,
              current: currentPage,
              onChange: (page) => setCurrentPage(page),
            }}
            showSorterTooltip={false}
            rowKey={(record) => record.id}
            components={components}
          />
        </div>
      </div>
    </div>
  </div>
  </div>
  </div>
  </div>
  )
}

export default TemperMaster